/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Custom styles for the SidenavItem
import { item, itemContent, itemArrow } from "examples/Sidenav/styles/sidenavItem";

import { collapseIcon } from "examples/Sidenav/styles/sidenavCollapse";

// Soft UI Dashboard PRO React contexts
import { useSoftUIController } from "context";

function SidenavItem({ name, active, nested, children, open, icon, ...rest }) {
  const [controller] = useSoftUIController();
  const { miniSidenav, transparentSidenav, sidenavColor, confirmations } = controller;

  let itemName = name;
  let itemSubName = "";
  let eventType = "regular";
  let itemBubble = itemName.indexOf("onfirmation") > -1 && confirmations ? confirmations : null;

  if (name.indexOf("(") > -1) {
    itemName = name.split("(")[0].trim();
    itemSubName = "(" + name.split("(")[1].split(")")[0].trim() + ")";

    if (itemName.indexOf("preGame") > -1) eventType = "pregame";
    if (itemName.indexOf("inPlay") > -1) eventType = "inplay";
  }

  return (
    <>
      <ListItem
        {...rest}
        component="li"
        sx={item}
        className={children ? `leaf-group ${eventType}` : `leaf ${eventType}`}
      >
        <SoftBox
          sx={(theme) => itemContent(theme, { active, miniSidenav, itemName, itemSubName, nested })}
        >
          <ListItemIcon className="leaf-icon">
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>
          <ListItemText
            className="leaf-text"
            primary={itemName}
            title={name.length > 20 ? name : null}
          />
          <ListItemText
            className="leaf-sub-text"
            primary={itemSubName}
            title={name.length > 20 ? name : null}
          />

          {children && (
            <Icon component="i" sx={(theme) => itemArrow(theme, { open, miniSidenav })}>
              expand_less
            </Icon>
          )}
          {itemBubble && <div className="bubble">{itemBubble}</div>}
        </SoftBox>
      </ListItem>
      {children && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

// Setting default values for the props of SidenavItem
SidenavItem.defaultProps = {
  active: false,
  nested: false,
  children: false,
  open: false,
};

// Typechecking props for the SidenavItem
SidenavItem.propTypes = {
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  nested: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.node,
  open: PropTypes.bool,
};

export default SidenavItem;
